function initSectionFaqs(scope) {
  const root = scope || document;
  const faqItems = root.querySelectorAll("#faq-section .faq-item");

  faqItems.forEach((item) => {
    if (item.dataset.faqBound === "true") return;

    const question = item.querySelector(".faq-question");
    const answer = item.querySelector(".faq-answer");

    if (!question || !answer) return;

    question.addEventListener("click", () => {
      const isActive = question.classList.contains("active");
      const groupRoot = item.closest("#faq-section") || document;
      const groupItems = groupRoot.querySelectorAll(".faq-item");

      groupItems.forEach((groupItem) => {
        const groupQuestion = groupItem.querySelector(".faq-question");
        const groupAnswer = groupItem.querySelector(".faq-answer");

        if (!groupQuestion || !groupAnswer) return;
        groupQuestion.classList.remove("active");
        groupAnswer.style.maxHeight = null;
      });

      if (!isActive) {
        question.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });

    item.dataset.faqBound = "true";
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initSectionFaqs());
} else {
  initSectionFaqs();
}

document.addEventListener("shopify:section:load", (event) => {
  initSectionFaqs(event.target);
});
